import { pilot } from '~/services/serviceInstances';

interface Request {
  label: string;
  client_id: string;
}

export const createClientSectionData = async ({
  label,
  client_id,
}: Request) => {
  const data = { label, client_id };

  const response = await pilot.post('client-sections/', data);

  return response;
};
